<template>
    <template v-for="menu in menus" :key="menu.id">
        <el-sub-menu style="-webkit-user-select:none; user-select: none;" v-if="menu?.children?.length" :index="menu.id">
            <template #title>
                <i :class="menu.icon"></i>
                <span>{{menu.label}}</span>
            </template>
            <tw-tablet-submenu :menus="menu.children"></tw-tablet-submenu>
        </el-sub-menu>
        <el-menu-item style="-webkit-user-select:none; user-select: none;" v-if="!menu?.children?.length" :index="menu.id">
            <i :class="menu.icon"></i>
            <template #title><span>{{menu.label}}</span></template>
        </el-menu-item>
    </template>
</template>

<script>
// 递归组件（用于创建菜单项，会自引用）
export default {
    name: 'tw-tablet-submenu',
    props: {
        menus: {
            type: Array,
            required: true
        }
    }
}
</script>

<style>

</style>